import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";

@Entity({update: "creditClaimComplete"})
export class CreditClaimComplete {

	@Field()
	public entityId: ID;

}


// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/CreditComplete.ts